{
  "id": "ra",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Rá",
    "en": "Ra"
  },
  "icon": "gods/ra",
  "portrait": "gods/ra-portrait",
  "modifiers": [
    {
      "target": "gatherRate",
      "op": "pct",
      "value": 0.3,
      "scope": {
        "sources": ["berries"]
      },
      "note": "Laborers gather from Berry Bushes 30% faster (BasePercent)."
    }
  ],
  "powers": ["rain"],
  "minors": {
    "classical": ["bast", "ptah"],
    "heroic": ["sekhmet", "sobek"],
    "mythic": ["osiris", "horus"]
  },
  "unlocks": ["skin-of-the-rhino"],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml, string_replacement_values.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Other bonuses: +15% hitpoints for Camel Riders, Chariot Archers and War Elephants; Priests can empower (60% of Pharaoh efficiency: x1.45 build/research/train, x1.12 favor/dropsite); Pharaoh-empowered Monuments empower nearby buildings (30 range, Priest strength). Rain recharge 90 s."
  },
  "fieldMeta": {
    "modifiers": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "ArchaicAgeRa: Gather WorkRate on WildCrops x1.30 BasePercent."
    }
  }
}
